/**
 * 公式的请求接口及相关方法
 * urlList  {
 *   path1: {
 *     path1-1: {
 *       // 页面api [path和页面路由一致（params部分忽略 如 /home/resource/resource -> home: {resource: {resource: {fn: url}}
 *       // functionName以 'GET' 开头的方法为get请求，返回请求url
 *       functionName: 'api_url',
 *       ...
 *     }
 *     functionName: 'api_url', // 当前路由节点下的公共api
 *   }
 *
 *   functionName: 'api_url, // 全局api
 *   ...
 * }
 *
 * 同名方法规则： 页面api > 路由节点下公共api > 全局api   (层级越深，优先级越高）
 *
 * 默认返回请求Promise对象 / GET时返回 String
 * */

const urlList = {
  home: {
    teacher: {
      detail: {
        NEWInfo: 'login/api/get_teacher_info', // 老师详情
      },
      NEWFollow: 'user/index/userFollowTeacher', // 删除/添加关注老师
    },
    video: {
      details: {
        getCourseList: 'resource.course/get_course_details',    // 获取课程详情和课时
        NEWRecommendList: 'login/api/get_subject_course',          // 获取专题课程推荐列表
        getTeacherList: 'resource.teacher/get_course_teacher',     // 老师列表
        NEWTeacherDetails: 'login/api/get_teacher_info',           // 老师详情
        getCourseVideoDetails: 'resource.resources_jd/get_resource_details', // 获取课时视频详情
        // saveCourseCollection: 'user/save_course_collection', // 课程收藏

      }
    },
    tbdetail: {
      getTag: 'resource.tag/get_tag', // 获取年级-学科-出版社
      getCourseList: 'resource.course/get_jd_course_list' // 获取同步课程列表
    },
    specialdetail: {
      NEWGetCourseTag: 'login/api/getSubjectCourseTagList', // 获取专题课程标签
      NEWGetSpecialCourse: 'login/api/get_subject_course',  // 获取专题课程列表
      getSubjectDetail: 'resource.subject/get_subject_detail' // 获取专题详情
    },
    search: {
      NEWCourseSearch: 'login/api/courseWebSearch', // 搜索课程
      NEWTeacherSearch: 'login/api/teacherSearch', // 搜索老师
      NEWTeacherDetails: 'login/api/get_teacher_info',  // 老师详情
			NEWTermSearch:'login/api/termSearch', //词条优化
    },

  },
  user: {
    collection: {
      del: 'user/many_del_collection', // 删除收藏
      list: 'user/get_my_collection_list', // 收藏列表
      // list: 'user/get_package_format_collection_list', // 收藏列表
    },
    course: {
      list: 'user/get_my_course_list', // 已购课程列表
    },
    follow: {
      NEWDel: 'user/index/userFollowTeacher', // 删除/添加关注
      NEWList: 'user/index/getUserTeacherList', // 关注列表
      NEWUpdateStatus: 'user/index/updateUserTeacherCourse', // 更新老师课程更新状态
    },
    play: {
      del: 'user/del_record', // 删除播放记录
      NEWList: 'user/index/resources_record_list', // 播放记录列表
      // list: 'user/get_format_resources_record_list', // 播放记录列表
    },
    vip: {
      NEWOrderList: 'user/api/get_order_list', // 订单列表
      NEWMyVip: 'user/api/get_vip_list', // 我的vip列表
      getAppInfo: 'product/get_app_version', // 我的vip产品详情
      getExchange: 'price.product/get_user_cards', // 已兑换列表
      userExchangeCode: 'price.product/use_card', // 使用兑换码
    },
    setting: {
      NEWMyVip: 'user/api/get_vip_list', // 我的vip列表
      // unbind: 'weixin_login/unbind_wx', // 解绑wx
      testPhoneCode: 'user/verify_phone_code',  // 验证手机验证码
      bindNewPhone: 'user/change_bind_phone', // 绑定新手机号
			NEWCancelUser:'user/index/cancel_user',//注销账号

    },
    remark: {
      NEWMyVip: 'user/api/get_new_vip_list', // 我的vip列表
    }
  },
  footer: {
    details: {
      NEWGetProtocol: 'login/api/get_protocol', // 获取协议
      NEWGetCfgInfo: 'footer/footer_api/info', // 获取底部信息栏配置
      sumbitFeedback: 'feedback/index', // 提交反馈
    }
  },
  help: {
    NEWSolveHelp: 'help/help_api/helpSolvedAdd', // 是否解决问题
    NEWGetCatalogue: 'help/help_api/helpCategroyLst', // 问题分类目录
    NEWGetHelpInfo: 'help/help_api/helpInfo', // 获取问题详情
    NEWGetSearchList: 'help/help_api/helpSearchLst', // 搜索问题
  },
  download: {
    NEWMyVip: 'user/api/get_vip_app_version', // 我的vip列表
    getAppInfo: 'product/get_app_version', // 我的vip产品详情
    GETDownloadLink: 'opening.opening/down_apk', // apk下载链接
  },
  // 登录
  NEWLogin: 'user/api/register',
  // 用户选择在读年级
  NEWSetGrade: 'user/Api/user_add_nianji',
	// 用户选择浏览年级
	NEWSetSelectGrade: 'user/Api/user_select_nianji',
  // wx登录
  NEWWxLogin: 'login/Api/web_register_wx_scancode',
  // wx登录绑定手机号
  NEWWxBind: 'login/Api/web_register_wx',
  // 绑定微信
  NEWBindWx: 'login/Api/web_bind_wx',
  // 扫码解绑wx
  NEWUnBindWx: 'user/index/qrcode_unbind_wx',
  // 用户详情
  NEWUserInfo: 'user/index/getUserInfo',
  // 微信关注登录二维码
  NEWWxQrCode: 'login/api/wxQrcodeCreate',
  // 微信关注登录
  NEWCheckCode: 'login/api/wxSceneStatus',
  // 短信验证码
  getPhoneCode: 'user/get_phone_code',
  // 绑定手机
  bindPhone: 'user/bind_phone',
  // 修改密码
  // NEWUpdatePassword: 'member/Api/update_password',
  updatePassword: 'user/update_password',
  // 获取年级列表
  getGrade: 'resource.tag/get_type',
  // 横版自定义页面接口
  NEWAutoPage: 'login/api/new_get_jp_page',
  // 音频课程列表
  getResourceList: 'resource.course/get_course_details',
  // 音频课时详情
  getResource: 'resource.resources_jd/get_format_resource_details',

  // 添加课时播放时长
  addResourceTime: 'user/add_playback_length',
  // 添加播放时长记录
  addPlayTimes: 'user/add_video_play_times',
  // 添加观看记录
  addPlayRecord: 'user/add_resources_record',
  // 添加课程播放记录
  addPlayCourse: 'user/add_course_record',
  // 收藏课程
  saveCourseCollection: 'user/save_course_collection',

  // 本月热门推荐
  NEWCoursePlayRanking: 'course/tourist/getCoursePlayRanking',
  // 本月热门搜索
  NEWKeywordSearch: 'course/tourist/getKeywordSearch',
  // 本月精品课程
  NEWCoursePayRanking: 'course/tourist/getCoursePayRanking',
  // 本月最受欢迎教师
  NEWHotTeacher: 'course/tourist/getHotTeacher',
  // 近期新课
  NEWCourse: 'course/tourist/getNewCourse',
  // 猜你喜欢
  NEWSubjectCourse: 'course/tourist/getSubjectCourse',

  // 播放记录列表
  // getCourseRecordList: 'user/get_format_resources_record_list',
  NEWCourseRecordList: 'user/index/resources_record_list',
  // // 获取VIP套餐列表
  // getVipList: 'price.product/get_new_vip_price_list',
	NEWGetVipList: 'vip/api/get_new_vip_price_list',
  // 微信二维码支付
  NEWWxPay: 'pay/api/wxQrcodePay',
  // 微信订单查询
  NEWWxQueryOrder: 'pay/api/wx_queryorder',
  // 支付宝二维码支付
  NEWZfbPay: 'pay/api/zfb_qrcode',
  // 支付宝订单查询
  NEWZfbQueryOrder: 'pay/api/zfb_queryorder',
	// 多支付订单查询
	NEWOrderQueryOrder: 'pay/api/order_queryorder',
  // 获取客服信息
  getKfInfo: 'product/get_service_info',
  // 获取未登录注册送会员图
  NEWActiveRegister: 'login/api/get_active_register_info',
  // 获取固定的VIP列表
  NEWVipList: 'user/api/get_new_vip_list',
  // 获取用户所有的会员
  NEWUserVipList:'user/api/get_vip_list',
  // 获取当前用户会员的产品id
  NEWGetProductId: 'user/Api/get_product_id',
  // 关注和取消关注老师
  NEWFollowTeacher: 'user/index/userFollowTeacher',
};

const apiList = {};

function getPath(key) {
  let path = location.hash.replace(/\?.*$/, '').split('/').slice(1);
  let list = JSON.parse(JSON.stringify(urlList));
  let url = '';
  for (let p of path) {
    if (typeof list[p] === 'object') {
      list = list[p];
      if (typeof list[key] === 'string') {
        url = list[key];
      }
    } else {
      break;
    }
  }
  if (url) {
    return url;
  } else if (typeof urlList[key] === 'string') {
    return urlList[key];
  }
  throw `未配置地址: ${path.join('.')}.${key}`;
}

function makeApiList(list, http) {
  Object.keys(list).map(k => {
    if (!apiList[k]) {
      if (typeof list[k] === 'string') {
        if (/^GET/.test(k)) {
          // get地址
          apiList[k] = (params = {}, config = {}) => {
            return http.download(getPath(k), params, {
              isSign: true,
              needXToken: true,
              ...config,
            });
          }
        } else if (/^NEW/.test(k)) {
          apiList[k] = (params = {}, config = {}) => {
            return http.$post1(getPath(k), params, config);
          }
        } else {
          // post请求
          apiList[k] = (params = {}, config = {}) => {
            return http.$post(getPath(k), params, config);
          }
        }
      } else {
        makeApiList(list[k], http);
      }
    }
  });
  return apiList;
}

export default (http) => {
  return makeApiList(urlList, http);
};